
























































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import {
  SwExpandableTextfield,
} from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import {
  SwTable,
  ColumnSortRequestData,
  SortedColumnInfo,
  TableColumnConfig,
  TableEntry,
  PaginationConfig,
  PageSizeChangeRequestData,
  PageNumberChangeRequestData,
  ColumnsAdjustRequestData,
} from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import {
  SwContentToolbar,
} from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { CreateElement, VNode } from 'vue';
import  { MswApiService } from '@/shared/msw-api-service';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import AddAffiliation from '../affiliation/add-affiliation.vue';
import ReviewAffiliation from '../affiliation/review-affiliation.vue';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import RevokeOrDeclineAff from './RevokeOrDeclineAff.vue';
import { SwButton } from '@libs-uuif/shared/sw-button';

const cssPrefix = 'affiliations-tab';

@Component({
  components: {
    SwExpandableTextfield,
    SwTable,
    SwContentToolbar,
    SwIconButton,
    SwIcon,
    SwButton,
    AddAffiliation,
    ReviewAffiliation,
    RevokeOrDeclineAff,
  },
})

export default class MswAffiliationsTab extends SwExtendedVue {
  cssPrefix = cssPrefix;

  searchInputText: string = '';
  currentPageNumber: number = 1;
  isExpandSearchFilter: boolean = false;
  affiliationListData: TableEntry[] = [];
  tempAffiliationData: TableEntry[] = [];
  sortedColumns: SortedColumnInfo[] = [{ ascending: true, colKey: 'OrganizatonName' }];
  adjustedColumns: ColumnsAdjustRequestData = {};
  globalSearchEmptyData: boolean = true;
  filterApplied: boolean = false;
  showAddAffiliation: boolean = false;
  displayReviewAffiliation: boolean = false;
  customerName: any = '';
  showRevoke: boolean = false;
  affId: any = '';
  displayData: any = {};
  filteredArray: any = [];

  get columnConfig(): TableColumnConfig[] {
    return [
      {
        key: 'OrgID',
        dataKey: 'OrgID',
        title: 'CustomerID',
        width: 100,
        sorter: true,
      },
      {
        key: 'OrganizatonName',
        dataKey: 'OrganizatonName',
        title: 'Customer Name',
        sorter: true,
      },
      {
        key: 'Location',
        dataKey: 'Location',
        title: 'Location',
        sorter: true,
        width: 120,
      },
      {
        key: 'Status',
        dataKey: 'Status',
        title: 'Status',
        sorter: true,
        width: 120,
      },
      {
        key: 'Scope',
        dataKey: 'Scope',
        title: 'Scope (tenant name)',
        width: 300,
        sorter: true,
        /* tslint:disable-next-line */
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              >{data.entry.isOwnTenant !== 'YES' && (
                    <div
                      style="margin-right:5px;"
                      class="sharedCustomer-dark widgetIcon"
                      v-tooltip={{
                        content: data.entry.tooltipText,
                        compact  : true,
                        placement: 'top',
                        maxWidth:275,
                      } as TooltipDirValues}
                    ></div>
                  )
                }
                <div>
                  {data.entry.Scope}
                </div>
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'UserGroup',
        dataKey: 'UserGroup',
        title: 'User Group',
        sorter: true,
      },
      {
        key: 'actions',
        dataKey: '',
        title: this.$t('products.actions')
        .toString(),
        render: (h: CreateElement, data: { entry: TableEntry }): VNode =>
          this.actionColumnRenderer(h, data),
      },
    ];
  }
  // tslint:disable-next-line:no-unused
  actionColumnRenderer(h: CreateElement, data: { entry: TableEntry }) {
    return (
      <div>
        {
          data.entry.showApprove === 'YES' &&
            <SwButton
              style="height: 24px"
              as-default
              nativeOn-click={() => this.approveAffiliation(data.entry)}
            >{(this.$t('affiliation.review.approve')
                .toString())}
            </SwButton>
        }
        {
          (data.entry.showDelete === 'YES') &&
          <span style="margin-left: 15px">
            <SwIcon
              name="trash"
              size={16}
              v-tooltip={{ content: (this.$t('affiliation.review.decline')
                .toString()), placement: 'top', compact: true }}
              nativeOn-click={() => this.declineOrRevokeAffiliation(data.entry, 'decline')}
            >
            </SwIcon>
          </span>
        }
        {
          (data.entry.showRevoke === 'YES') &&
          <span style="margin-left: 15px">
            <SwIcon
              name="trash"
              size={16}
              v-tooltip={{ content: (this.$t('affiliation.review.revoke')
                .toString()), placement: 'top', compact: true }}
              nativeOn-click={() => this.declineOrRevokeAffiliation(data.entry, 'revoke')}
            >
            </SwIcon>
          </span>
        }
      </div>
    ) as VNode;
  }

  paginationConfig: PaginationConfig = {
    pageNumber: 1,
    pageSize: 50,
    datasetTotal: 0,
    datasetOffset: 0,
    pageSizeOpts: [10, 20, 50, 100],
  };

  approveAffiliation(val: any) {
    this.customerName = val.OrganizatonName;
    this.affId = val.affiliationID;
    this.displayReviewAffiliation = true;
  }

  closeModalOfRevoke(val: boolean) {
    if (val) {
      this.addOrRevoke(this.displayData.details, 'revoke');
    } else {
      this.showRevoke = false;
    }
  }

  declineOrRevokeAffiliation(val: any, modeVal: any) {
    if (modeVal === 'revoke') {
      let text = '';
      if (val.isOwnTenant === 'YES') {
        text = `${this.$t('affiliation.revokeAffOwn1')}${val.OrganizatonName}${this.$t('affiliation.revokeAffOwn2')}`;
      } else {
        text = `${this.$t('affiliation.revokeAffShared1')}${val.OrganizatonName}.${this.$t('affiliation.revokeAffShared2')}`;
      }
      this.displayData = {
        showText: text,
        details: val,
      };
      this.showRevoke = true;
    } else {
      confirmService.confirm({
        status: 'informational',
        title: String(this.$t('products.confirmation')),
        message: `${modeVal === 'revoke' ? String(this.$t('affiliation.revokeAff'))
        : String(this.$t('affiliation.declineAff'))}${val.OrganizatonName} ?`,
        buttons: [{ key: 'cancel', name: String(this.$t('common.cancel')) }, { key: 'ok', name: String(this.$t('products.ok')) }],
      })
      .then((key: any) => {
        if (key === 'ok') this.addOrRevoke(val, modeVal);
      });
    }
  }

  addOrRevoke(val: any, modeVal: any) {
    const req = {
      affiliationID: val.affiliationID,
      mode: modeVal,
    };
    this.$store.commit('startLoading');
    MswApiService.affiliations.reviewAffiliation(req)
    .then((resp: any) => {
      if (resp.operationStatus === 'OK') {
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        if (modeVal === 'revoke') this.showRevoke = false;
        this.getAffiliationsList();
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      }
    })
    .catch((err:any) => {
      console.error(err);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }
  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => col.colKey === data.colKey);
    if (index < 0) {
      if (data.cancel) {
        return;
      }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  applyGlobalSearchFilter() : void {
    const searchText = this.searchInputText.trim();
    if (searchText !== '') {
      this.resetPagination();
      this.$store.commit('startLoading');
      this.filteredArray = this.tempAffiliationData.filter((item: any) => {
        let flag: boolean = false;
        if (item.OrganizatonName !== undefined && item.OrganizatonName.toLowerCase()
        .indexOf(searchText.toLowerCase()) > -1 || item.OrgID !== undefined && item.OrgID.toLowerCase()
        .indexOf(searchText.toLowerCase()) > -1 || item.Location !== undefined && item.Location.toLowerCase()
        .indexOf(searchText.toLowerCase()) > -1 || item.Scope !== undefined && item.Scope.toLowerCase()
        .indexOf(searchText.toLowerCase()) > -1 || item.Status !== undefined && item.Status.toLowerCase()
        .indexOf(searchText.toLowerCase()) > -1 || item.UserGroup !== undefined && item.UserGroup.toLowerCase()
        .indexOf(searchText.toLowerCase()) > -1) {
          flag = true;
        }
        if (flag) {
          return item;
        }
        this.paginationConfig.pageNumber = 1;
        this.filterApplied = true;
      }) as TableEntry[];
      this.$store.commit('stopLoading');
    }
  }

  closeAffDialog(val: boolean) {
    this.showAddAffiliation = false;
    if (val) this.getAffiliationsList();
  }

  closeReviewAffiliation(val: boolean) {
    console.warn('from close', val);
    this.displayReviewAffiliation = false;
    if (val) this.getAffiliationsList();
  }

  onApplyGlobalFilter(event: any) {
    const searchText = this.searchInputText.trim();
    if (searchText !== '' && event.keyCode === 13) {
      this.globalSearchEmptyData = true;
      this.applyGlobalSearchFilter();
    } else if (searchText === '' && this.globalSearchEmptyData) {
      this.globalSearchEmptyData = false;
      this.filterApplied = false;
      this.affiliationListData = this.tempAffiliationData;
    }
  }

  addNewAffiliation() {
    this.showAddAffiliation = true;
  }

  getAffiliationsList() {
    this.$store.commit('startLoading');
    MswApiService.affiliations.getAffiliationList()
    .then((resp: any) => {
      if (resp.msgId === '100' && resp.operationStatus === 'OK') {
        this.affiliationListData =  resp.content.affiliations || [];
        this.affiliationListData.forEach((el: any, index: number) => {
          el['_key'] = index + 1;
        });
        this.tempAffiliationData = this.affiliationListData;
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      }
      this.$store.commit('stopLoading');
    })
    .catch(() => {
      this.$store.commit('stopLoading');
    });
  }

  onChangePageNumber(data: PageNumberChangeRequestData) : void {
    if (this.paginationConfig.pageNumber !== data.pageNumber) {
      this.paginationConfig.pageNumber = data.pageNumber;
      this.currentPageNumber = data.pageNumber;
    }
  }

  onChangePageSize(data: PageSizeChangeRequestData) {
    this.paginationConfig.pageSize = data.pageSize;
    /** we also need to make sure the page number is within the reasonable range */
    this.paginationConfig.pageNumber = Math.min(
      this.paginationConfig.pageNumber,
      Math.ceil(this.affiliationListData.length / this.paginationConfig.pageSize),
    );
  }

  resetPagination() : void {
    this.paginationConfig.datasetTotal = 0;
    this.paginationConfig.pageNumber = 1;
  }

  created() {
    this.getAffiliationsList();
  }
}
